// Generated by CoffeeScript 1.12.7
(function() {
  var InspectedObjectLiteral, compare;

  compare = require('../Eq').compare;

  module.exports = InspectedObjectLiteral = (function() {
    InspectedObjectLiteral.inspectedObjectLiteral = function(literal, isError) {
      return new InspectedObjectLiteral(literal, isError);
    };

    function InspectedObjectLiteral(literal1, isError1) {
      this.literal = literal1;
      this.isError = isError1;
    }

    InspectedObjectLiteral.prototype.getInspectedObjects = function() {
      return this;
    };

    InspectedObjectLiteral.prototype.inspect = function() {
      return this.literal;
    };

    InspectedObjectLiteral.prototype.compare = function(b) {
      return compare(this.literal, b.literal);
    };

    return InspectedObjectLiteral;

  })();

}).call(this);

//# sourceMappingURL=InspectedObjectLiteral.js.map
